import React, { useState } from 'react';

import { javaApi } from '../../utils/AxiosInstance';

import styles from '../../styles/timebase-testseries.module.scss';
import Fixmock from '../HomePage/HeroSection/Fixmock';
import Exploretest from './Exploretest';
import TestseriseCard from './TestseriseCard';
// import TestseriesList from './TestseriesList';
import TopHeader from './TopHeader';

function Timebasetest() {
  const [viewAll, setviewAll] = useState('showall');
  const mobiledResposivewrapper = 'mobiledResposivewrapper';
  const [fixmockdata, setfixmockdata] = useState([]);

  React.useEffect(() => {
    (async () => {
      const response = await javaApi.get('app-test-series-ws/api/v1/test-series/mock-test/list');
      if (response?.data?.success) {
        setfixmockdata(response?.data?.data);
      } else {
        setfixmockdata([]);
      }
    })();
  }, []);
  const handleViewAll = () => {
    setviewAll('hide');
  };
  return (
    <div className={styles.container}>
      <div className={styles[viewAll]}>
        <TopHeader />
        {fixmockdata?.length > 0 && (
          <div className={styles.fixmock}>
            <Fixmock fixmockdata={fixmockdata} />
          </div>
        )}{' '}
        <div className={styles.testseriesExploreWrapper}>
          <TestseriseCard handleViewAll={handleViewAll} />
          <Exploretest />
        </div>
      </div>
      {viewAll !== 'showall' && (
        <div className={`${styles[mobiledResposivewrapper + viewAll]}`}>
          <div className={styles.showAllData}>
            <TestseriseCard handleViewAll={handleViewAll} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Timebasetest;
